import React from 'react';
import ReactSVG from 'react-svg';
import { TimeToRespondIcon } from '~/assets/svgIcons';
import { useTranslation } from '~/dependencies';
import { Chip } from './styles';

const TTRExpiredBadge = () => {
  const { t } = useTranslation();

  return (
    <Chip
      data-test-id="sla-expired-badge"
      title={t('screens.conversation.ttrBadge.expired')}
      label={t('screens.conversation.ttrBadge.expired')}
      avatar={<ReactSVG src={TimeToRespondIcon} />}
    />
  );
};

export default TTRExpiredBadge;
